import { Box, Button, Chip, Collapse, Link, ListSubheader, MenuItem, Paper, TableContainer, Table, TableBody, TableRow, TableCell,  TablePagination, makeStyles, useTheme, TableHead, IconButton } from '@material-ui/core';
import React from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { useToggle } from 'react-use';
import TextField from './Patient/fiche-clinique/styled/TextField';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeSearchAdvancedFiltersSelector, makeSearchAdvancedPatientsSelector, tagsSelector } from '../redux/Patients/selectors';
import { correspondantsSelector } from '../redux/Correspondants/selectors';
import { useMemo } from 'react';
import { getTagsPatientsRoutine, searchAdvancedFilterRoutine, searchAdvancedPatientsRoutine } from '../redux/Patients/routines';
import { getCorrespondantsRoutine } from '../redux/Correspondants/routines';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { makeParamsSelector } from '../redux/Params/selectors';
import { collectionKeysEqualityFn, dictKeysEqualityFn } from '../utils/equality';
import PrintIcon from '@material-ui/icons/Print';
import { useHistory } from 'react-router';
import Loading from './Loading';
import { ErrorOutline } from '@material-ui/icons';
import { useUserArrayParam } from '../utils/hooks';
import { patients } from '../utils/api';
import { tokenSelector } from '../redux/Auth/selectors';
import DateRangePickerTest from './Tasks/DateRangePickerTest';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: "flex",
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  filter_chip: {
    marginRight: theme.spacing(1)
  },
  favorite_row: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  favorite_input: {
    minWidth: 220,
  },
  print_table: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    "& th, & td": {
      border: '1px solid black',
      borderCollapse: 'collapse',
    }
  },
  table_row: {
    cursor: "pointer",
    '&:nth-of-type(odd)': {
      //backgroundColor: theme.palette.action.hover,
    },
  }
}))

function getAge(dateofbirth, t) {
  const duration = moment.duration(moment().diff(moment(dateofbirth)))
  const years = duration.years()
  const months = duration.months()
  return  t('common:interface.date', {date: dateofbirth}) + ` (${`${years ? t('common:interface.year', {count: years}): ''} ${months ? t('common:interface.month', {count: months}) : ''}`.trim()})`
}

function NumberOperatorSelect(props) {
  const {t} = useTranslation()
  return (
    <TextField 
      select
      {...props}
    >
      <MenuItem value="eq">{t('advanced_search.Equal to')}</MenuItem>
      <MenuItem value="lt">{t('advanced_search.Less than')}</MenuItem>
      <MenuItem value="lte">{t('advanced_search.Less than or équal to')}</MenuItem>
      <MenuItem value="gt">{t('advanced_search.Greater than')}</MenuItem>
      <MenuItem value="gte">{t('advanced_search.Greater than or équal to')}</MenuItem>
      <MenuItem value="between">{t('advanced_search.Between')}</MenuItem>
    </TextField>
  )
}

const useFilterFormStyles = makeStyles(theme => ({
  input: {
    width: 250,
    marginRight: theme.spacing(2)
  },

}))

function FilterForm({
  selectedFilter,
  toogleShowAddFilterForm,
  showAddFilterForm,
  filters = {},
  set,
  traitementCategories = [],
  tagOptions = [],
  correspondantOptions = [],
  ...props
}) {
  const classes = useFilterFormStyles()
  const theme = useTheme()
  const [filterForm, setFilterForm] = useState({
    filter: "",
    opetrator: undefined,
    value: undefined,
  })
  const [filter, setFilter] = useState("")
  const [operator, setOperator] = useState("")
  const [value, setValue] = useState("")
  const {t, i18n} = useTranslation()
  const paramsSelector = useMemo(makeParamsSelector, [])
  const  timelineParams = useSelector(state => paramsSelector(state, `fiche-clinique-timeline-list`), collectionKeysEqualityFn(['id', 'updatedAt']))
  const timelineElts = useMemo(() => timelineParams[0]?.value || [], [timelineParams])

  useEffect(() => {
    const nextFilter = filters[selectedFilter]?.filter || ""
    const nextOperator = filters[selectedFilter]?.operator || ""
    setFilter(nextFilter)
    if (nextFilter === "patient_tag") {
      setOperator(nextOperator === 'all' ? 'all' : 'any')
    } else {
      setOperator(nextOperator || "")
    }
    const nextValue = filters[selectedFilter]?.value
    setValue(Array.isArray(nextValue) ? nextValue : (nextValue || ""))
  }, [selectedFilter, showAddFilterForm])

  const handleApplyFilter = () => {
    if(filter === "patient_age")
      set(selectedFilter || uuidv4(), {
        filter,
        operator,
        value,
        params: {
          age: value,
          age_op: operator,
        }
      })
    else if(filter === "patient_sexe")
      set(selectedFilter || uuidv4(), {
        filter,
        value,
        params: {
          gender: value,
        }
      })
    else if(filter === "categorie_traitement")
      set(selectedFilter || uuidv4(), {
        filter,
        value,
        params: {
          categorie_traitement: value,
        }
      })
    else if(filter === "patient_tag")
      if (!Array.isArray(value) || value.length === 0) {
        setFilter("")
        setOperator("")
        setValue([])
        toogleShowAddFilterForm()
        return
      } else
      {
        const tagMode = operator === 'all' ? 'all' : 'any'
        set(selectedFilter || uuidv4(), {
          filter,
          operator: tagMode,
          value,
          params: {
            tag: value,
            tag_mode: tagMode,
          }
        })
      }
    else if(filter === "patient_correspondant")
      if (!value) {
        setFilter("")
        setOperator("")
        setValue("")
        toogleShowAddFilterForm()
        return
      } else
      set(selectedFilter || uuidv4(), {
        filter,
        value,
        params: {
          correspondant: value,
        }
      })
    else if(filter === "patient_postcode")
      if (!value) {
        setFilter("")
        setOperator("")
        setValue("")
        toogleShowAddFilterForm()
        return
      } else
      set(selectedFilter || uuidv4(), {
        filter,
        value,
        params: {
          postcode: value,
        }
      })
    else if(filter === "patient_city")
      if (!value) {
        setFilter("")
        setOperator("")
        setValue("")
        toogleShowAddFilterForm()
        return
      } else
      set(selectedFilter || uuidv4(), {
        filter,
        value,
        params: {
          city: value,
        }
      })
    else if(filter === "recontact_date")
      if (operator === 'between') {
        set(selectedFilter || uuidv4(), {
          filter,
          operator,
          value,
          params: {
            recontact_date_from: value?.from || '',
            recontact_date_to: value?.to || '',
            recontact_op: operator,
          }
        })
      } else {
        set(selectedFilter || uuidv4(), {
          filter,
          operator,
          value,
          params: {
            recontact_date: value,
            recontact_op: operator,
          }
        })
      }
    else if(["previous_periode", "current_periode", "next_periode"].includes(filter) && ['exists', 'not_exists'].includes(operator) )
      set(selectedFilter || uuidv4(), {
        filter,
        operator,
        params: {
          [filter+'_exists']: operator === 'exists',
        }
      })
    else if(["previous_periode", "current_periode", "next_periode"].includes(filter) && ['is'].includes(operator) )
      set(selectedFilter || uuidv4(), {
        filter,
        operator,
        value,
        params: {
          [filter+'_name']: value,
        }
      })
    else if(["previous_periode", "current_periode", "next_periode"].includes(filter) && ['eq', 'lt', 'gt'].includes(operator) )
      set(selectedFilter || uuidv4(), {
        filter,
        operator,
        value,
        params: {
          [filter+'_number']: value,
          [filter+'_number_op']: operator,
        }
      })
    else if(["first_contact", "last_contact"].includes(filter))
      if (operator === 'between') {
        set(selectedFilter || uuidv4(), {
          filter,
          operator,
          value,
          params: {
            [filter+'_date_from']: value?.from || '',
            [filter+'_date_to']: value?.to || '',
            [filter+'_op']: operator,
          }
        })
      } else {
        set(selectedFilter || uuidv4(), {
          filter,
          operator,
          value,
          params: {
            [filter+'_date']: value,
            [filter+'_op']: operator,
          }
        })
      }
    setFilter("")
    setOperator("")
    setValue("")
    toogleShowAddFilterForm()
  }

  const handleFilterChange = (e) => {
    setFilter(e.target.value)
    if(e.target.value === "patient_age") {
      setOperator("eq")
      setValue(12)
    }
    else if(e.target.value === "patient_sexe") {
      setOperator("eq")
      setValue("male")
    }
    else if(e.target.value === "categorie_traitement") {
      setOperator("is")
      setValue(traitementCategories[0] || "")
    }
    else if(e.target.value === "patient_tag") {
      setOperator("any")
      setValue(tagOptions.length ? [tagOptions[0]] : [])
    }
    else if(e.target.value === "patient_correspondant") {
      setOperator("")
      setValue(correspondantOptions[0]?.id || "")
    }
    else if(e.target.value === "patient_postcode") {
      setOperator("")
      setValue("")
    }
    else if(e.target.value === "patient_city") {
      setOperator("")
      setValue("")
    }
    else if(e.target.value === "recontact_date") {
      setOperator("eq")
      setValue(moment().format('YYYY-MM-DD'))
    }
    else if(['previous_periode', 'current_periode', 'next_periode'].includes(e.target.value)) {
      setOperator("exists")
    }
    else if(['first_contact', 'last_contact'].includes(e.target.value)) {
      setOperator("eq")
      setValue(moment().format('YYYY-MM-DD'))
    }
  }

  const handleDateOperatorChange = (e) => {
    const newOp = e.target.value;
    setOperator(newOp);
    if (newOp === 'between') {
      setValue({ from: null, to: null });
    } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      setValue(moment().format('YYYY-MM-DD'));
    }
  };

  const rangePresets = useMemo(() => [
    {
      key: "today",
      label: t("tasks.Today"),
      getRange: () => { const start = moment().startOf("day"); return [start, start.clone().endOf("day")]; },
    },
    {
      key: "this_week",
      label: t("tasks.This week"),
      getRange: () => [moment().startOf("isoWeek"), moment().endOf("isoWeek")],
    },
    {
      key: "this_month",
      label: t("tasks.This month"),
      getRange: () => [moment().startOf("month"), moment().endOf("month")],
    },
    {
      key: "last_month",
      label: t("tasks.Last month"),
      getRange: () => { const last = moment().subtract(1, "month"); return [last.clone().startOf("month"), last.clone().endOf("month")]; },
    },
    {
      key: "this_quarter",
      label: t("tasks.This quarter"),
      getRange: () => [moment().startOf("quarter"), moment().endOf("quarter")],
    },
    {
      key: "last_quarter",
      label: t("tasks.Last quarter"),
      getRange: () => { const last = moment().subtract(1, "quarter"); return [last.clone().startOf("quarter"), last.clone().endOf("quarter")]; },
    },
    {
      key: "this_year",
      label: t("tasks.This year"),
      getRange: () => [moment().startOf("year"), moment().endOf("year")],
    },
  ], [t]);

  const handlePeriodeOperatorChange = (e) => {
    setOperator(e.target.value)
    if(['eq', 'lt', 'gt'].includes(e.target.value)) {
      setValue(1)
    }
    else if(e.target.value === "is") {
      setValue(timelineElts[0].name)
    }
  }

  return (
    <Collapse in={showAddFilterForm}>
      <Box display="flex" paddingBottom={2}>
        <Box flex={1} display="flex">
          <TextField 
            className={classes.input} 
            select 
            size='small' 
            variant='outlined'  
            value={filter} 
            onChange={handleFilterChange}
            SelectProps={{
              displayEmpty: true,
            }}
          >
            <MenuItem value="" disabled>
              {t('advanced_search.Select filter')}
            </MenuItem>
            <ListSubheader>{t('advanced_search.Patient')}</ListSubheader>
            <MenuItem value="patient_age">{t('advanced_search.Age')}</MenuItem>
            <MenuItem value="patient_sexe">{t('advanced_search.Sex')}</MenuItem>
            <MenuItem value="categorie_traitement">{t('patient.categorie')}</MenuItem>
            <MenuItem value="patient_tag">{t('form:patient.tags.label')}</MenuItem>
            <MenuItem value="patient_correspondant">{t('form:patient.correspondants')}</MenuItem>
            <MenuItem value="patient_postcode">{t('form:patient.postcode')}</MenuItem>
            <MenuItem value="patient_city">{t('form:patient.city')}</MenuItem>
            <MenuItem value="recontact_date">{t('form:patient.recontact_date')}</MenuItem>
            <ListSubheader>{t('advanced_search.Périods')}</ListSubheader>
            <MenuItem value="previous_periode">{t('advanced_search.Previous period')}</MenuItem>
            <MenuItem value="current_periode">{t('advanced_search.Current period')}</MenuItem>
            <MenuItem value="next_periode">{t('advanced_search.Next period')}</MenuItem>
            <ListSubheader>{t('advanced_search.Contacts')}</ListSubheader>
            <MenuItem value="first_contact">{t('advanced_search.First contact')}</MenuItem>
            <MenuItem value="last_contact">{t('advanced_search.Last contact')}</MenuItem>
          </TextField>
          {
            filter === "patient_age" &&
            <>
              <NumberOperatorSelect className={classes.input} size='small' variant='outlined' value={operator} onChange={(e) => setOperator(e.target.value)} />
              <TextField className={classes.input} size='small' variant='outlined' type="number" inputProps={{min: "0", max: "99"}} value={value} onChange={(e) => setValue(e.target.value)} />
            </>
          }
          {
            filter === "patient_sexe" &&
            <>
              <TextField className={classes.input} select size='small' variant='outlined' value={value} onChange={(e) => setValue(e.target.value)} >
                <MenuItem value="male">{ t('form:patient.gender.male')}</MenuItem>
                <MenuItem value="female">{t('form:patient.gender.female')}</MenuItem>
              </TextField>
            </>
          }
          {
            filter === "categorie_traitement" &&
            <>
              <TextField className={classes.input} select size='small' variant='outlined' value={value} onChange={(e) => setValue(e.target.value)} >
                {
                  traitementCategories.length === 0 &&
                  <MenuItem value="" disabled>{t('common:interface.Aucun élément')}</MenuItem>
                }
                {
                  traitementCategories.map((cat) => (
                    <MenuItem key={cat} value={cat}>{cat}</MenuItem>
                  ))
                }
              </TextField>
            </>
          }
          {
            filter === "patient_tag" &&
            <>
              <TextField
                className={classes.input}
                select
                size='small'
                variant='outlined'
                value={operator || "any"}
                onChange={(e) => setOperator(e.target.value)}
              >
                <MenuItem value="any">{t('advanced_search.Any of')}</MenuItem>
                <MenuItem value="all">{t('advanced_search.All of')}</MenuItem>
              </TextField>
              <TextField
                className={classes.input}
                select
                size='small'
                variant='outlined'
                value={Array.isArray(value) ? value : []}
                onChange={(e) => setValue(e.target.value)}
                SelectProps={{
                  multiple: true,
                  renderValue: (selected) => (Array.isArray(selected) ? selected.join(', ') : ''),
                }}
              >
                {
                  tagOptions.length === 0 &&
                  <MenuItem value="" disabled>{t('common:interface.Aucun élément')}</MenuItem>
                }
                {
                  tagOptions.map((tag) => (
                    <MenuItem key={tag} value={tag}>{tag}</MenuItem>
                  ))
                }
              </TextField>
            </>
          }
          {
            filter === "patient_correspondant" &&
            <>
              <TextField className={classes.input} select size='small' variant='outlined' value={value} onChange={(e) => setValue(e.target.value)} >
                {
                  correspondantOptions.length === 0 &&
                  <MenuItem value="" disabled>{t('common:interface.Aucun élément')}</MenuItem>
                }
                {
                  correspondantOptions.map((correspondant) => (
                    <MenuItem key={correspondant.id} value={correspondant.id}>{correspondant.label}</MenuItem>
                  ))
                }
              </TextField>
            </>
          }
          {
            filter === "patient_postcode" &&
            <>
              <TextField className={classes.input} size='small' variant='outlined' value={value} onChange={(e) => setValue(e.target.value)} />
            </>
          }
          {
            filter === "patient_city" &&
            <>
              <TextField className={classes.input} size='small' variant='outlined' value={value} onChange={(e) => setValue(e.target.value)} />
            </>
          }
          {
            ['previous_periode', 'current_periode', 'next_periode'].includes(filter) &&
            <>
              <TextField className={classes.input} select size='small' variant='outlined' value={operator} onChange={handlePeriodeOperatorChange} >
                <MenuItem value="exists">{t('advanced_search.Exist')}</MenuItem>
                <MenuItem value="not_exists">{t('advanced_search.Does not exist')}</MenuItem>
                <MenuItem value="is">{t('advanced_search.is of type')}</MenuItem>
                <MenuItem value="eq">{t('advanced_search.whose number is equal')}</MenuItem>
                <MenuItem value="gt">{t('advanced_search.whose number is greater than')}</MenuItem>
                <MenuItem value="lt">{t('advanced_search.whose number is less than')}</MenuItem>
              </TextField>
              {
                ['eq', 'gt', 'lt'].includes(operator) &&
                <TextField className={classes.input} size='small' variant='outlined' type="number" inputProps={{min: "0", max: "99"}} value={value} onChange={(e) => setValue(e.target.value)} />
              }
              {
               operator === 'is' &&
               <TextField className={classes.input} select size="small" variant='outlined' value={value} onChange={(e) => setValue(e.target.value)}>
                {
                  timelineElts.map(elt => (
                    <MenuItem key={elt.id} value={elt.name}>
                      {elt.name}
                    </MenuItem>
                  ))
                }
               </TextField>
              }
            </>
          }
          {
            ['first_contact', 'last_contact', 'recontact_date'].includes(filter) &&
            <>
              <NumberOperatorSelect className={classes.input} size='small' variant='outlined' value={operator} onChange={handleDateOperatorChange} />
              {operator !== 'between' && (
                <TextField className={classes.input} size='small' variant='outlined' type="date" style={{colorScheme: theme.palette.type}} value={typeof value === 'string' ? value : ''} onChange={(e) => setValue(e.target.value)} />
              )}
              {operator === 'between' && (
                <DateRangePickerTest
                  outlined
                  value={[
                    value?.from ? moment(value.from, 'YYYY-MM-DD') : null,
                    value?.to ? moment(value.to, 'YYYY-MM-DD') : null,
                  ]}
                  onChange={(range) => {
                    const [start, end] = range || [];
                    setValue({
                      from: start && start.isValid() ? start.format('YYYY-MM-DD') : null,
                      to: end && end.isValid() ? end.format('YYYY-MM-DD') : null,
                    });
                  }}
                  locale={i18n.language}
                  startText={t('tasks.From')}
                  endText={t('tasks.To')}
                  presets={rangePresets}
                  presetsTitle={t('tasks.Date presets')}
                />
              )}
            </>
          }
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          <Box width={theme.spacing(2)}></Box>
          <Link component="button" underline="hover" color="inherit" variant='body2' onClick={toogleShowAddFilterForm}>{t('advanced_search.Cancel')}</Link>
          <Box width={theme.spacing(2)}></Box>
          <Button color="secondary" variant="outlined" size="small" onClick={handleApplyFilter}>{t('advanced_search.Apply filter')}</Button>
        </Box>
      </Box>
    </Collapse>
  )
}

function AdvancedSearch () {
  const dispatch = useDispatch();
  //const [filters, {set, setAll, remove, reset}] = useMap()
  const theme = useTheme()
  const {t, i18n} = useTranslation()
  const classes = useStyles()
  const [showAddFilterForm, toogleShowAddFilterForm] = useToggle(false)
  const [selectedFilter, setSelectedFilter] = useState()
  const history = useHistory()
  const token = useSelector(tokenSelector);
  const [favorites, addFavorite, removeFavorite, setFavorites] = useUserArrayParam('advanced-search-favorites', []);
  const [selectedFavoriteId, setSelectedFavoriteId] = useState("");
  const [favoriteName, setFavoriteName] = useState("");

  const defaultTraitementCategories = useMemo(() => ([
    { id: uuidv4(), name: t('patient.traitement_categories.a_recontacter') },
    { id: uuidv4(), name: t('patient.traitement_categories.surveillance') },
    { id: uuidv4(), name: t('patient.traitement_categories.interception') },
    { id: uuidv4(), name: t('patient.traitement_categories.multi_attaches') },
    { id: uuidv4(), name: t('patient.traitement_categories.gouttieres') },
    { id: uuidv4(), name: t('patient.traitement_categories.lingual') },
    { id: uuidv4(), name: t('patient.traitement_categories.contention') },
    { id: uuidv4(), name: t('patient.traitement_categories.surveillance_dents_sagesse') },
    { id: uuidv4(), name: t('patient.traitement_categories.fin_de_traitement') },
    { id: uuidv4(), name: t('patient.traitement_categories.archive') },
  ]), [t]);
  const [traitementCategoriesRaw] = useUserArrayParam('traitement-categorie', defaultTraitementCategories);
  const traitementCategories = useMemo(() => (
    (traitementCategoriesRaw || [])
      .map((cat) => (typeof cat === 'string' ? cat : cat?.name))
      .filter(Boolean)
  ), [traitementCategoriesRaw]);

  const tagEntities = useSelector(tagsSelector) || [];
  const tagOptions = useMemo(() => (
    (tagEntities || [])
      .map((tag) => (typeof tag === 'string' ? tag : tag?.tag))
      .filter(Boolean)
  ), [tagEntities]);

  const correspondants = useSelector(correspondantsSelector) || [];
  const correspondantOptions = useMemo(() => (
    (correspondants || [])
      .map((correspondant) => {
        const id = correspondant?.id || correspondant?._id || '';
        if (!id) return null;
        const label = [correspondant?.firstname, correspondant?.lastname].filter(Boolean).join(' ').trim()
          || correspondant?.name
          || id;
        return { id: String(id), label };
      })
      .filter(Boolean)
  ), [correspondants]);

  useEffect(() => {
    dispatch(getTagsPatientsRoutine.trigger());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCorrespondantsRoutine.trigger());
  }, [dispatch]);

  const operatrion_map = useMemo(() => ({
    'eq': '=',
    'lt': '<',
    'lte': '<=',
    'gte': '>=',
    'gt': '>',
    'between': ': ',
    'is': ': ',
    'any': ': ' + t('advanced_search.Any of'),
    'all': ': ' + t('advanced_search.All of'),
    'exists': ': ' + t('advanced_search.Exist'),
    'not_exists': ': '+ t('advanced_search.Does not exist'),
    undefined: ':',
  }), [])

  const filter_map = useMemo(() => ({
    'patient_age': t('advanced_search.Age'),
    'patient_sexe': t('advanced_search.Sex'),
    'categorie_traitement': t('patient.categorie'),
    'patient_tag': t('form:patient.tags.label'),
    'patient_correspondant': t('form:patient.correspondants'),
    'patient_postcode': t('form:patient.postcode'),
    'patient_city': t('form:patient.city'),
    'recontact_date': t('form:patient.recontact_date'),
    'previous_periode': t('advanced_search.Previous period'),
    'current_periode': t('advanced_search.Current period'),
    'next_periode': t('advanced_search.Next period'),
    'first_contact': t('advanced_search.First contact'),
    'last_contact': t('advanced_search.Last contact'),
  }), [])

  const searchAdvancedPatientsSelector = useMemo(makeSearchAdvancedPatientsSelector, [])
  
  const {
    result = [],
    page = 0,
    size = 20,
    searchCount = 0,
    error = false,
    loading = false,
  } = useSelector(searchAdvancedPatientsSelector)

  const searchAdvancedFiltersSelector = useMemo(makeSearchAdvancedFiltersSelector, [])
  const filters = useSelector(searchAdvancedFiltersSelector, dictKeysEqualityFn(['filter', 'operator', 'value'])) || {}
  
  console.log('filters', filters)
  
  const set = useCallback((id, value) => {
    dispatch(searchAdvancedFilterRoutine.set({
      id,
      value
    }))
  }, [])

  const remove = useCallback((id) => {
    dispatch(searchAdvancedFilterRoutine.remove({id}))
  }, [])

  const reset = useCallback(() => {
    dispatch(searchAdvancedFilterRoutine.reset())
  }, [])

  const snapshotFilters = useCallback(() => {
    return JSON.parse(JSON.stringify(filters || {}));
  }, [filters]);

  const applyFavoriteFilters = useCallback((favorite) => {
    if (!favorite) return;
    dispatch(searchAdvancedFilterRoutine.reset());
    const favFilters = favorite.filters || {};
    Object.entries(favFilters).forEach(([id, value]) => {
      dispatch(searchAdvancedFilterRoutine.set({ id, value }));
    });
  }, [dispatch]);

  const handleSelectFavorite = useCallback((event) => {
    const selectedId = event.target.value;
    setSelectedFavoriteId(selectedId);
    const favorite = (favorites || []).find((fav) => fav.id === selectedId);
    if (favorite) {
      setFavoriteName(favorite.name || '');
      applyFavoriteFilters(favorite);
    } else {
      setFavoriteName('');
    }
  }, [favorites, applyFavoriteFilters]);

  const handleSaveFavorite = useCallback(() => {
    const name = (favoriteName || '').trim() || t('advanced_search.New favorite');
    const newId = uuidv4();
    addFavorite({
      id: newId,
      name,
      filters: snapshotFilters(),
    });
    setSelectedFavoriteId(newId);
    setFavoriteName(name);
  }, [addFavorite, favoriteName, snapshotFilters, t]);

  const handleUpdateFavorite = useCallback(() => {
    const index = (favorites || []).findIndex((fav) => fav.id === selectedFavoriteId);
    if (index < 0) return;
    const next = [...favorites];
    next[index] = {
      ...next[index],
      name: (favoriteName || '').trim() || next[index].name,
      filters: snapshotFilters(),
    };
    setFavorites(next);
  }, [favorites, favoriteName, selectedFavoriteId, setFavorites, snapshotFilters]);

  const handleRenameFavorite = useCallback(() => {
    const index = (favorites || []).findIndex((fav) => fav.id === selectedFavoriteId);
    if (index < 0) return;
    const next = [...favorites];
    next[index] = {
      ...next[index],
      name: (favoriteName || '').trim() || next[index].name,
    };
    setFavorites(next);
  }, [favorites, favoriteName, selectedFavoriteId, setFavorites]);

  const handleDeleteFavorite = useCallback(() => {
    const index = (favorites || []).findIndex((fav) => fav.id === selectedFavoriteId);
    if (index < 0) return;
    removeFavorite(index);
    setSelectedFavoriteId('');
    setFavoriteName('');
  }, [favorites, removeFavorite, selectedFavoriteId]);

  const search_params = Object.values(filters).reduce((acc, {params}) => ({...acc, ...params}) , {})
  const search_params_str = new URLSearchParams(search_params).toString()
  console.log('search_params', search_params)
  
  useEffect(() => {
    if(!showAddFilterForm)
      setSelectedFilter()
  }, [showAddFilterForm])

  useEffect(() => {
    setSelectedFilter()
    dispatch(searchAdvancedPatientsRoutine.trigger({
      page: 0, 
      size, 
      ...search_params
    }))
  }, [search_params_str])

  const handleChangePage = (event, newPage) => {
    dispatch(searchAdvancedPatientsRoutine.trigger({
      page: newPage, 
      size,
      ...search_params
    }))
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(searchAdvancedPatientsRoutine.trigger({
      page: 0, 
      size: parseInt(event.target.value, 10),
      ...search_params
    }))
  };

  const printHtmlInIframe = useCallback((html) => {
    if (!html) return;

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.style.visibility = "hidden";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow?.document;
    if (!iframeDoc) return;

    iframe.onload = () => {
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.focus();
        iframeWindow.print();
      }
      setTimeout(() => {
        if (iframe.parentNode) {
          document.body.removeChild(iframe);
        }
      }, 1000);
    };

    iframeDoc.open();
    iframeDoc.write(html);
    iframeDoc.close();
  }, []);

  const handlePrint = useCallback(async () => {
    if (!token) return;
    try {
      const response = await patients.advancedSearchPrint(token, {
        ...search_params,
        locale: i18n.language,
      });
      const html = response?.data;
      printHtmlInIframe(html);
    } catch (error) {
      console.error("Erreur impression recherche avancée:", error);
    }
  }, [i18n.language, printHtmlInIframe, search_params, token]);

  return (
    <div className={classes.root}>
      <Box component={Paper}  display="flex"   flexDirection='column' padding={2} variant="outlined">
        <Box className={classes.favorite_row}>
          <TextField
            className={classes.favorite_input}
            select
            size="small"
            variant="outlined"
            label={t('advanced_search.Favorites')}
            value={selectedFavoriteId}
            onChange={handleSelectFavorite}
          >
            <MenuItem value="">{t('advanced_search.No favorite')}</MenuItem>
            {
              (favorites || []).map((fav) => (
                <MenuItem key={fav.id} value={fav.id}>{fav.name}</MenuItem>
              ))
            }
          </TextField>
          <TextField
            className={classes.favorite_input}
            size="small"
            variant="outlined"
            label={t('advanced_search.Favorite name')}
            value={favoriteName}
            onChange={(e) => setFavoriteName(e.target.value)}
          />
          <Button variant="outlined" size="small" onClick={handleSaveFavorite}>{t('advanced_search.Save favorite')}</Button>
          {
            selectedFavoriteId && (
              <>
                <Button variant="outlined" size="small" onClick={handleUpdateFavorite}>{t('advanced_search.Update favorite')}</Button>
                <Button variant="outlined" size="small" onClick={handleRenameFavorite}>{t('advanced_search.Rename favorite')}</Button>
                <Button variant="outlined" size="small" onClick={handleDeleteFavorite}>{t('advanced_search.Delete favorite')}</Button>
              </>
            )
          }
          <Box flexGrow={1} />
          { 
            !showAddFilterForm &&
            <Box display="flex" justifyContent="flex-end">
              <Box width={theme.spacing(2)}></Box>
              { Object.keys(filters).length > 0 &&
                <Link component="button" underline="hover" color="inherit" variant='body2' onClick={reset}>{t('advanced_search.Reset')}</Link>
              }
              <Box width={theme.spacing(2)}></Box>
              <Button variant="outlined" size="small" onClick={toogleShowAddFilterForm}>{t('advanced_search.Add filter')}</Button>
              <Box marginLeft={1}>
                <IconButton size='small' onClick={handlePrint}>
                  <PrintIcon/>
                </IconButton>
              </Box>
            </Box>
          }
        </Box>
        <FilterForm
          filters={filters}
          selectedFilter={selectedFilter}
          set={set}
          showAddFilterForm={showAddFilterForm}
          toogleShowAddFilterForm={toogleShowAddFilterForm}
          traitementCategories={traitementCategories}
          tagOptions={tagOptions}
          correspondantOptions={correspondantOptions}
        />
        <Box  display="flex" >
          <Box flex={1}>
            {
              Object.entries(filters).map(([key,elt]) => (
                <Chip
                  key={key}
                  label={`${filter_map[elt.filter]} ${operatrion_map[elt.operator]} ${
                    elt.filter === 'patient_sexe' ? t('form:patient.gender.'+elt.value) :
                      elt.filter === 'patient_tag' ? (Array.isArray(elt.value) ? elt.value.join(', ') : elt.value) :
                      elt.filter === 'patient_correspondant' ? (correspondantOptions.find((c) => c.id === elt.value)?.label || elt.value) :
                      ['first_contact', 'last_contact', 'recontact_date'].includes(elt.filter) ? (elt.operator === 'between' ? `${t('common:interface.date', {date: elt.value?.from})} → ${t('common:interface.date', {date: elt.value?.to})}` : t('common:interface.date', {date: elt.value})) :
                        elt.value ? elt.value : ""
                  }`}
                  variant='outlined'
                  size='small'
                  className={classes.filter_chip}
                  onDelete={() => remove(key)}
                  onClick={() => {
                    setSelectedFilter(key)
                    toogleShowAddFilterForm(true)
                  }}
                />
              ))
            }
          </Box>
          {/* { 
            !showAddFilterForm &&
            <Box display="flex" justifyContent="flex-end">
              <Box width={theme.spacing(2)}></Box>
              { Object.keys(filters).length > 0 &&
                <Link component="button" underline="hover" color="inherit" variant='body2' onClick={reset}>{t('advanced_search.Reset')}</Link>
              }
              <Box width={theme.spacing(2)}></Box>
              <Button variant="outlined" size="small" onClick={toogleShowAddFilterForm}>{t('advanced_search.Add filter')}</Button>
              <Box marginLeft={1}>
                <IconButton size='small' onClick={handlePrint}>
                  <PrintIcon/>
                </IconButton>
              </Box>
            </Box>
          } */}
        </Box>
      </Box>
      <Box flex={1} display="flex" flexDirection="column" overflow="hidden">
        <Box component={TableContainer} flex={1} display={"flex"} flexDirection="column">
          <Table
            className={classes.table}
            stickyHeader
            size={'small'}
          >
            <TableHead>
              <TableRow>
                <TableCell rowSpan={2}>
                  {t('advanced_search.Lastname')}
                </TableCell>
                <TableCell rowSpan={2}>
                  {t('advanced_search.Firstname')}
                </TableCell>
                <TableCell rowSpan={2}>
                  {t('advanced_search.Date of birth')}
                </TableCell>
                <TableCell colSpan={2} align='center'>
                  {t('advanced_search.Previous period')}
                </TableCell>
                <TableCell colSpan={2} align='center'>
                  {t('advanced_search.Current period')}
                </TableCell>
                <TableCell colSpan={2} align='center'>
                  {t('advanced_search.Next period')}
                </TableCell>
                <TableCell rowSpan={2}>
                  {t('advanced_search.First contact date')}
                </TableCell>
                <TableCell rowSpan={2}>
                  {t('advanced_search.Last contact date')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{top: 37}}>
                  {t('advanced_search.Type')}
                </TableCell>
                <TableCell style={{top: 37}}>
                  {t('advanced_search.Number')}
                </TableCell>
                <TableCell style={{top: 37}}>
                  {t('advanced_search.Type')}
                </TableCell>
                <TableCell style={{top: 37}}>
                  {t('advanced_search.Number')}
                </TableCell>
                <TableCell style={{top: 37}}>
                  {t('advanced_search.Type')}
                </TableCell>
                <TableCell style={{top: 37}}>
                  {t('advanced_search.Number')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                !loading && !error &&
                result.map((patient) => (
                  <TableRow key={patient._id} hover  onClick={() => history.push(`/patient/${patient._id}`)} className={classes.table_row}>
                    <TableCell component="th" scope="row" >
                      {patient.lastname}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {patient.firstname}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {getAge(patient.dateofbirth, t)}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {patient.previous_periode?.name}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {patient.previous_periode?.number}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {patient.current_periode?.name}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {patient.current_periode?.number}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {patient.next_periode?.name}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {patient.next_periode?.number}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {t('common:interface.date', {date: patient.first_contact})}
                    </TableCell>
                    <TableCell component="th" scope="row" >
                      {t('common:interface.date', {date: patient.last_contact})}
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
          {
            loading &&
            <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
              <Loading/>
            </Box>
          }
          {
            error &&
            <Box display="flex" justifyContent="center" alignItems="center" flex={1} flexDirection={'column'}>
              <ErrorOutline color="error" fontSize="large"/>
              <Box marginTop={2}>
                {t('common:interface.an error occured')}
              </Box>
            </Box>
          }
        </Box>
        <TablePagination
          rowsPerPageOptions={[20, 50, 100]}
          component="div"
          count={searchCount}
          rowsPerPage={size}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </div>
  );
}

export default AdvancedSearch
